import { createOcapiClient } from '@vista-digital/ocapi-client';
import { ApiClientProvider } from '../types/api-client-provider';
export class OcapiClientProvider extends ApiClientProvider {
    constructor() {
        super(...arguments);
        this.update = (config) => {
            this.client = createOcapiClient(config);
        };
    }
}
//# sourceMappingURL=provider.js.map